import Validator from "validator";

export const loginValidation = data => {
  let errors = {};

  data.email = data.email.trim() ? data.email : "";
  data.password = data.password.trim() ? data.password : "";

  if (!Validator.isEmail(data.email)) {
    errors.email = "Email is invalid";
  }

  if (Validator.isEmpty(data.email)) {
    errors.email = "Email field is required";
  }

  if (Validator.isEmpty(data.password)) {
    errors.password = "Password field is required";
  }

  return {
    errors,
    isValid: Object.keys(errors).length === 0
  };
};

export const forgotPasswordValidation = data => {
  let errors = {};

  data.email = data.email.trim() ? data.email : "";

  if (!Validator.isEmail(data.email)) {
    errors.email = "Email is invalid";
  }

  if (Validator.isEmpty(data.email)) {
    errors.email = "Email field is required";
  }

  return {
    errors,
    isValid: Object.keys(errors).length === 0
  };
};

export const changePasswordValidation = data => {
  let errors = {};
  data.password = data.password.trim() ? data.password : "";
  data.new_password = data.new_password.trim() ? data.new_password : "";
  data.confirm_password = data.confirm_password.trim()
    ? data.confirm_password
    : "";

  if (Validator.isEmpty(data.password)) {
    errors.password = "Password field is required";
  }
  if (Validator.isEmpty(data.new_password)) {
    errors.new_password = "New password field is required";
  }
  if (Validator.isEmpty(data.confirm_password)) {
    errors.confirm_password = "Confirm password field is required";
  }

  if (!Validator.equals(data.new_password, data.confirm_password)) {
    errors.confirm_password = "Passwords must match";
  }

  return {
    errors,
    isValid: Object.keys(errors).length === 0
  };
};



// WEBPACK FOOTER //
// ./src/validation/validation.js